import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

type TradeMode = 'MultiplePositions' | 'OneWay';

/**
 * WS doc : https://www.notion.so/prextech/RFC-One-Way-Mode-Tech-Spec-WIP-135eb32ad227800eb31ce300a565232c?pvs=4
 * 다른 소켓들과 포맷을 맞추기 위해 accountId key를 추가함
 * */
type AccountId = string;
export type AccountType = Record<AccountId, Account> | null;

export interface Account {
  tradeMode: TradeMode;
  dailyNetDepositInUsdt: string;
  bonusReductionRatio: string;
  maxInitLeverageRestriction?: number;
  totalCopyingBalanceInUsdt: string;
}

export const accountAtom = atom<AccountType | null>(null);

export const subscribeAccountBunja = createTableAccumulatorBunja(
  'private/account',
  (store) => (wsData) => store.set(accountAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
subscribeAccountBunja.debugLabel = 'subscribeAccountBunja';
